import React from 'react'
import { useForm } from 'react-hook-form'
import { useModal } from '../../../../components/useModal'
import { getImageURL } from '../../../../lib/utils/getImageURL'
import { Button } from '@demandlocal/components'
import { ReactComponent as CDKLogo } from '../../../../images/cdk_logo.svg'
import { ReactComponent as DealerVaultLogo } from '../../../../images/vendors/dealer_vault_icon.svg'
import { ReactComponent as TekionLogo } from '../../../../images/vendors/tekion_logo.svg'
import { ReactComponent as DriveCentricLogo } from '../../../../images/vendors/drive_centric_logo.svg'
import { ReactComponent as EleadLogo } from '../../../../images/vendors/eleads_logo.svg'
import { ReactComponent as GoogleAdsLogo } from '../../../../images/vendors/google_ads_logo.svg'
import ThirdPartyConnectSource from './ConnectSource'
import { useNavigate } from 'react-router'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import { useTranslation } from 'react-i18next'

const SourcePickerThirdParty = ({ type }: { type: string }): JSX.Element => {
  const { handleSubmit } = useForm({ mode: 'onSubmit' })
  const { handleModal } = useModal()
  const navigate = useNavigate()
  const dealership = useDealership()
  const { t } = useTranslation('routes')

  const onSuccess = (): void => {
    navigate(t('dealership.customers.sources.list', { dealership }))
  }

  return (
    <form
      onSubmit={handleSubmit(() => null)}
      className={
        'py-10 px-6 rounded-lg font-Spartan flex-1 flex items-center flex-col bg-cultured-gray'
      }>
      <div className={'flex-1 flex flex-col items-center'}>
        <div className={'font-bold text-base'}>Connect a 3rd party {type} source</div>
        <div className={'font-medium pt-2  text-xs text-davy-gray'}>
          Automate your import
        </div>
      </div>
      <div className={'pt-12 flex flex-col  items-center justify-center w-full px-6'}>
        <div className={'flex flex-row items-center justify-center pb-4 gap-2 flex-wrap'}>
          <ThirdPartyIntegratedSources type={type} />
        </div>
        <Button
          variant={'secondary'}
          onClick={(e) => {
            e.preventDefault()
            handleModal(
              <ThirdPartyConnectSource sourceType={type} onSuccess={onSuccess} />,
            )
          }}>
          Connect
        </Button>
      </div>
    </form>
  )
}

const ThirdPartyIntegratedSources = ({ type }: { type: string }): JSX.Element => {
  if (type === 'sales') {
    return (
      <>
        <CDKLogo className={'max-h-[48px]'} />
        <img
          src={getImageURL('images/dealer_socket_logo.png')}
          className={'max-h-[48px]'}
        />
        <DealerVaultLogo className={'max-h-[48px]'} />
        <TekionLogo className="max-h-[32px]" />
        <DriveCentricLogo className={'max-h-[32px]'} />
      </>
    )
  } else if (type === 'service') {
    return (
      <>
        <CDKLogo className={'max-h-[48px]'} />
        <img
          src={getImageURL('images/dealer_socket_logo.png')}
          className={'max-h-[48px]'}
        />
        <DealerVaultLogo />
        <TekionLogo className="max-h-[32px]" />
      </>
    )
  } else if (type === 'leads') {
    return (
      <>
        <div
          className={
            'flex bg-white rounded-full justify-center items-center p-1.5 h-16 w-16'
          }>
          <EleadLogo className="max-w-[48px]" />
        </div>
        <GoogleAdsLogo className={'max-h-[48px] w-16'} />
        <img
          src={getImageURL('images/vendors/facebook_ads_logo.png')}
          className={'max-h-[48px]'}
        />
        <TekionLogo className="max-h-[32px]" />
      </>
    )
  } else {
    return <></>
  }
}

export default SourcePickerThirdParty
